import { AxiosInstance } from 'axios';
import { ReportStatus } from '@declarations/common/enums/ReportStatus';
import { RiskLevel } from '@declarations/common/enums/RiskLevel';

export type FacilitiesMMRSByStatus =
  {
    facilityId: number;
    facilityName: string;
    reports: [{
      status: ReportStatus;
      count: number;
    }]
  };

export default function getFacilitiesMedicalsByStatus(api: AxiosInstance) {
  return (riskLevel?: RiskLevel, organizationId?: number, yearOfMrrs?: number) => api.get<FacilitiesMMRSByStatus[]>('/facilities-counts-by-status', {
    params: {risk_level: riskLevel, organization_id: organizationId, year_of_mrrs: yearOfMrrs},
  });
}
